<div class="import-file-row">
  <div class="import-file-row-title">
    <fw-icon class="icon" size="medium" color="typography">{{ file.fileType || file.fileName | fileImg }}</fw-icon>
    <div [matTooltip]="name" matTooltipClass="break-word" class="import-file-row-title-name">
      {{ name }}
    </div>
  </div>
  <div class="import-file-row-contains"></div>
  <div class="import-file-row-size">
    {{ file.size | storageUnit }}
  </div>
  <div class="import-file-row-status">
    <fw-chip
      *ngIf="file.status === statusEnum.Complete || file.status === statusEnum.Error; else loading"
      [color]="getStatusClass(file.status)"
      [title]="file.status"
      [matTooltip]="(file.completedPartsSize | storageUnit) + ' completed'"
    >
    </fw-chip>
    <fw-icon-button
      *ngIf="file.isDicomFailure"
      icon="copy-item"
      size="small"
      (click)="copyErrorToClipboard(file)"
      [matTooltip]="file.failureReason"
    ></fw-icon-button>
    <ng-template #loading>
      <div class="import-file-row-status-loader">
        <mat-progress-bar
          mode="determinate"
          [value]="progress"
          [color]="progress === 100 ? 'accent' : 'primary'"
        ></mat-progress-bar>
        <div>{{ progress }}%</div>
      </div>
    </ng-template>
  </div>
  <div class="import-file-row-actions">
    <fw-icon-button
      *ngIf="file.status === statusEnum.Error && !file.isDicomFailure"
      icon="rotate-refresh"
      size="small"
      (click)="retry.emit(file)"
      [matTooltip]="'localImport.fileStatus.labels.retryUpload' | translate"
    ></fw-icon-button>
    <fw-icon-button
      icon="close-circled"
      color="slate"
      size="small"
      (click)="cancel.emit(file)"
      [matTooltip]="'localImport.fileStatus.labels.cancelUpload' | translate"
    ></fw-icon-button>
  </div>
</div>
